import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { FaqAccordion } from "@/components/FaqAccordion";
import { messengerLink } from "@/config/site";
import { Seo } from "@/components/Seo";
import { crumbs, faqJsonLd } from "@/config/seo";

export default function Faq() {
  return (
    <div data-testid="faq-page" className="pt-32">
      <Seo
        title="FAQ — Metal Prints, Orders & Payment | MetalMuse"
        description="Answers about MetalMuse metal prints: how to order, photo requirements, durability, delivery times, anime posters, gifts and service areas across Saskatchewan."
        path="/faq"
        keywords="metal print FAQ, how to order metal print, are metal prints durable, metal print delivery Saskatchewan"
        jsonLd={[crumbs([{ name: 'Home', path: '/' }, { name: 'FAQ', path: '/faq' }]), faqJsonLd()]}
      />
      <section className="container-lux max-w-4xl pb-24">
        <SectionHeader eyebrow="FAQ" title="Everything you need to know" text="Can't find your answer? Message us on Facebook or WhatsApp — we reply fast." />
        <FaqAccordion />
        <Reveal className="mt-14 flex flex-col sm:flex-row gap-4">
          <Link to="/order" data-testid="faq-order-cta" className="inline-flex items-center justify-center gap-2 bg-white text-black font-tech text-xs uppercase tracking-[0.2em] font-semibold px-8 py-4 rounded-full hover:bg-cyan-200 transition-[background-color,box-shadow,transform] duration-300 shadow-[0_0_20px_rgba(0,229,255,0.3)] hover:-translate-y-1">
            Order Your Metal Print <ArrowRight size={18} />
          </Link>
          <a href={messengerLink} target="_blank" rel="noopener noreferrer" data-testid="faq-messenger-cta" className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-medium px-8 py-4 rounded-full hover:bg-white/5 transition-colors duration-300">
            Message Us on Facebook
          </a>
        </Reveal>
      </section>
    </div>
  );
}
